import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ResourceService } from '../resource-service.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import * as XLSX from 'xlsx';
import { HttpClient } from '@angular/common/http';
import { WebService } from '../shared/services/web.service';
import { Location } from '@angular/common';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-resource-detail',
  templateUrl: './resource-detail.component.html',
  styleUrls: ['./resource-detail.component.css'],
})


export class ResourceDetailComponent implements OnInit {
  records: any = [];
  pdfSrc: SafeResourceUrl;
  resourceDetail: any = [];
  isExcelFile: boolean = false;
  excelData: unknown[];
  fileUrl: string = 'https://css4.pub/2015/icelandic/dictionary.pdf';
  pdfSrcUrl: void;
  resourcesList: any[];
  resourceUrl: any;
  showLoad: boolean = false;
  bucketUrl = environment.BUCKET_URL;
  
  constructor(
    private route: ActivatedRoute,
    private resourceService: ResourceService,
    private sanitizer: DomSanitizer,
    private http: HttpClient,
    private webapi: WebService,
    private location: Location
  ) {}

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
     
      // const resourceURL = params.get('id');
      // this.resourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(resourceURL);
      // console.log('Resource URL:', this.resourceUrl);

      const resourceId = Number(params.get('id'));
      this.getResourceList(resourceId);
 
    });

  }

  getResourceList(resourceId: number): void {
    this.showLoad = true;
    this.webapi.requestJson('getResourceDetail', { resource_id : resourceId}).subscribe(
      (data) => {
        let response = JSON.parse(data.body);
        console.log("this is response",response)
        const matchResource = response.resource
        console.log("matched resource", matchResource)
        this.records = {...matchResource}
        if (matchResource.resource_path) {
          this.resourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`${this.bucketUrl}${matchResource.resource_path}`);
          console.log("this is resource url", this.resourceUrl)
          // this.records = {...records}
        } else {
          this.resourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(matchResource.resource_url);
        }
        this.showLoad = false;
      },
      (error) => {
        // this.isLoading = false;
        this.showLoad = false;

        console.error('ERROR', error);
      }
    );
  }

  // ngOnInit() {
  //   this.route.paramMap.subscribe((params) => {
  //     const resourceId = Number(params.get('id'));
  //     this.resourceService
  //       .getResourceRecordsById(resourceId)
  //       .then((records) => {
  //         this.pdfSrcUrl = records.resource_url;
  //         // this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(records.resource_url);
  //         // this.sanitizer.bypassSecurityTrustResourceUrl(records.resource_url);
  //         this.records = { ...records };
  //       })
  //       .catch((error) => {
  //         console.error(error);
  //       });
  //   });
  // }

  isPDF(src: any): boolean {
    return src.changingThisBreaksApplicationSecurity
      .toLowerCase()
      .endsWith('.pdf');
  }

  isExcel(src: any): boolean {
    return (
      src.changingThisBreaksApplicationSecurity
        .toLowerCase()
        .endsWith('.xlsx') || src.toLowerCase().endsWith('.xls')
    );
  }

  fetchExcelData() {
    const excelUrl =
      'https://noritz-equip-assets.s3.us-west-1.amazonaws.com/Data Refresh Sample Data.xlsx';
    this.http.get(excelUrl, { responseType: 'arraybuffer' }).subscribe(
      (data: ArrayBuffer) => {
        const workbook = XLSX.read(new Uint8Array(data), { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        this.excelData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
      },
      (error) => {
        console.error('Error fetching Excel file:', error);
      }
    );
  }


  getFirstLetter(name: string): string {
    return name.charAt(0).toUpperCase();
  }

  getMoreTagsContent(tags): string[] {
    return tags.slice(2).map((tag) => tag.tag_name);
  }

  moreTagsContent: string[];

  updateMoreTagsContent(tags): void {
    this.moreTagsContent = this.getMoreTagsContent(tags);
  }

  resetMoreTagsContent(): void {
    this.moreTagsContent = [];
  }

  goBack() {
    this.location.back(); // Navigates to the previous route
  }
}
